import { Alert, Button, Typography } from '@ecdlink/ui';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useStoreSetup } from '@/hooks/useStoreSetup';
import ROUTES from '@/routes/routes';
import * as styles from '@/components/loader/loader.styles';

import { TIMEOUTS } from '@/constants/TimeOuts';

const Loader = ({ loadingMessage = 'Loading . . .' }) => {
  const history = useHistory();

  const { resetAuth } = useStoreSetup();

  const [showIssue, setShowIssue] = useState<boolean>(false);

  useEffect(() => {
    // Check for connection type and set timeout accordingly.
    // This gives slower connections more time to not throw false positives for issues.
    const connectionType: string = (window.navigator as any).connection
      .effectiveType as string;
    const issueTimeout =
      TIMEOUTS[connectionType].loadIssueTime || TIMEOUTS['4g'].loadIssueTime;

    const timer = setTimeout(() => {
      setShowIssue(true);
    }, issueTimeout);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`z-50 flex w-full flex-col items-center justify-between ${styles.container}`}
    >
      <div className="flex h-screen flex-col items-center justify-center"></div>
      {showIssue && (
        <div className="flex flex-col items-center justify-center px-4 py-4">
          <Alert
            type={'warning'}
            message={
              'Having issues? Go back to the login screen here to allow for a reset'
            }
            button={
              <Button
                color="textMid"
                type="filled"
                size="small"
                onClick={async () => {
                  await resetAuth();
                  // await resetAppStore();
                  history.push(ROUTES.LOGIN);
                }}
              >
                <Typography
                  color="white"
                  text={'Reset & Go back to login'}
                  type="small"
                />
              </Button>
            }
          />
        </div>
      )}
    </div>
  );
};

export default Loader;
